<template>
  <el-dialog
    :width="width"
    :visible.sync="modelValue.visibleAddDialog"
    custom-class="report-found"
    append-to-body
    title="添加巡查记录"
  >
    <!-- <div class="found-title">添加巡查记录</div> -->
    <step-list :stepList="stepList" :active="modelValue.active" />

    <ganged-control
      :limitEditSingle="limitReportAdd"
      v-model="modelValue"
      v-bind:detailData.sync="reportDetail"
      @onSaveAllClick="$emit('onSaveAllClick')"
      @onCancelEdit="$emit('onCancelEdit')"
      @onSavePart="$emit('onSavePart')"
    >
      <component
        v-bind:reportDetail.sync="reportDetail"
        v-bind:visibleEdit.sync="modelValue.visibleEdit"
        v-bind:is="reportComponent"
      ></component>
    </ganged-control>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="active = active - 1">取消</el-button>
      <el-button type="primary" @click="active = active + 1">下一步</el-button>
    </span> -->
    <!-- <el-input v-model="reportDetail.user"></el-input> -->
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
const found_map = new Map([
  [1, { component: 'reportFoundBaseVue' }],
  [2, { component: 'reportFoundImgboxVue' }],
  [3, { component: 'reportFoundOtherVue' }],
  [4, { component: 'reportFoundOtherVue' }]
]);
import { modelMixin } from '../../assets/js/mixins/model';
import { roleJudge } from '../../config/roleJudge';
import GangedControl from '../layout/ganged-control.vue';
import stepList from '../layout/step-list.vue';
import reportFoundBaseVue from './report-found-base.vue';
import reportFoundImgboxVue from './report-found-imgbox.vue';
import reportFoundOtherVue from './report-found-other.vue';
export default {
  name: 'ReportFound',
  components: {
    stepList,
    reportFoundBaseVue,
    reportFoundOtherVue,
    GangedControl,
    reportFoundImgboxVue
  },
  props: {
    reportDetail: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [modelMixin],
  data() {
    return {
      stepList: ['基本信息', '上传照片', '其他信息']
    };
  },

  computed: {
    ...mapState('login', ['authorizationLimit', 'isMobile']),
    reportComponent() {
      const { component } = found_map.get(this.modelValue.active + 1);
      return component;
    },
    limitReportAdd() {
      return roleJudge(this.authorizationLimit, 4);
    },
    width() {
      return !this.isMobile ? '680px' : '100vw';
    }
  },

  methods: {
    handleSaveReportInfo() {},
    handleCancelReportInfo() {}
  }
};
</script>

<style lang="scss">
.report-found {
  .edit-header {
    border: 0px !important;
  }
  .el-dialog {
    &__header {
      height: 44px;
      line-height: 44px;
      background-color: $color-primary;
      padding: 0;
    }
    &__title {
      color: #fff;
      margin-left: 10px;
    }
    &__body {
      padding: 28px 24px;
      overflow-y: auto;
      height: 831px;
      padding-bottom: 50px;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .found {
    &-title {
      position: absolute;
      top: 0;
      left: 0;
      color: #fff;
      line-height: 44px;
      width: 100%;
      height: 44px;
      background-color: $color-primary;
    }
  }
}
@media screen and (max-width: 750px) {
  .report-found {
    .edit-header {
      border: 0px !important;
    }
    .el-dialog {
      &__header {
        height: 44px;
        line-height: 44px;
        background-color: $color-primary;
        padding: 0;
      }
      &__title {
        color: #fff;
        margin-left: 10px;
      }
      &__body {
        padding: 28px 24px;
        overflow-y: auto;
        height: calc(100vh - 44px);
      }
      &__headerbtn {
        display: flex;
        font-size: 30px;
        color: #fff;
        top: 7px;
        right: 11px;
      }
      &__close {
        color: #fff;
      }
    }
    .found {
      &-title {
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        line-height: 44px;
        width: 100%;
        height: 44px;
        background-color: $color-primary;
      }
    }
  }
}
</style>
